$(() => {

    $('.information-tile__front').on('click', function () {
        $(this).closest('.information-tile__item').addClass("information-tile__item--is-active");
    });

    $('.information-tile__back-header').on('click', function () {
        $(this).closest('.information-tile__item').removeClass("information-tile__item--is-active");
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/information-tile.js